<template>
    <a-layout id="admin-layout">
        <a-affix :offset-top="0" style="z-Index:200">
            <a-layout-header class="header">
                <a-row >
                    <a-col :span="4">
                        <div id="logo" class="logo-wrapper">
                            <a href="/" class="router-link-active">
                                <img :src="siteInfo.logo"
                                    class="logo-image" v-if="siteInfo.logo" />
                            </a>
                        </div>
                    </a-col>
                    <a-col :span="20">
                        <a-dropdown placement="bottomCenter">
                            <div class="header-right">
                                <a-avatar :size="34"
                                    :src="userInfo && userInfo.team_id ? userInfo.team_user_avatar ? userInfo.team_user_avatar : avatar : userInfo.avatar ? userInfo.avatar : avatar"
                                    class="header-avatar" />
                                <span class="header-right-name">{{ userInfo && userInfo.name }}</span>
                                <div class="header-right-text">
                                    <span v-if="userInfo.team_id > 0">{{ $t('enum.userLevel.3') }}</span>
                                    <span v-else>{{ $t(`enum.userLevel.${userInfo.level}`) }}</span>
                                </div>
                            </div>
                            <template v-slot:overlay>
                                <a-menu class="ant-pro-drop-down menu">
                                    <a-menu-item key="center" v-if="userInfo && userInfo.type === 1"
                                        @click="$router.push({ name: 'admin-home' })">
                                        <a-icon type="user" />
                                        {{ $t('common.adminBackground') }}
                                    </a-menu-item>
                                    <a-menu-item key="center01" v-else-if="userInfo && userInfo.type === 2"
                                        @click="$router.push({ name: 'agent-home' })">
                                        <a-icon type="user" />
                                        {{ $t('common.agentBackground') }}
                                    </a-menu-item>
                                    <a-menu-item @click="$router.push({ name: 'member-account' })"
                                        v-if="userInfo && userInfo.type === 3">
                                        <a-icon type="setting" />
                                        {{ $t('common.memberCenter') }}
                                    </a-menu-item>
                                    <a-menu-item @click="$router.push({ name: 'agent-account' })"
                                        v-else-if="userInfo && userInfo.type === 2">
                                        <a-icon type="setting" />
                                        {{ $t('common.memberCenter') }}
                                    </a-menu-item>
                                    <a-menu-item @click="goHome" v-if="userInfo && userInfo.type === 3">
                                        <a-icon type="home" />
                                        {{ $t('common.memberHome') }}
                                    </a-menu-item>
                                    <a-menu-item @click="openChangeMember">
                                        <a-icon type="sync" />
                                        {{ $t('common.memberChange') }}
                                    </a-menu-item>
                                    <a-menu-divider />
                                    <a-menu-item key="logout" @click="onClickLoginout">
                                        <a-icon type="logout" />
                                        {{ $t('common.logout') }}
                                    </a-menu-item>
                                </a-menu>
                            </template>
                        </a-dropdown>

                        <a-menu mode="horizontal" :default-selected-keys="activeTopbarMenu" :style="{
                            lineHeight: '61px', background: 'rgba(1, 92, 97)',
                            color: 'rgba(241, 254, 255)', float: 'right'
                        }">
                            <a-menu-item @click="handleMenuClick" :key="resolvePath(memberRoutes[0].path, route.path)"
                                v-for="route in topbarMenus">
                                <span>{{ $t(`moduleTitles.${route.meta.title}`) }}</span>
                            </a-menu-item>
                            <a-menu-item @click="handleMenuClick" key="/member/pcpublish/live">
                                <span>{{ $t(`moduleTitles.pclive`) }}</span>
                            </a-menu-item>
                            <!-- 全景發佈 -->
                            <!-- <a-button type="primary" @click="handlePublishClick">{{$t(`moduleTitles.pcpublish`)}}</a-button> -->
                            <a-dropdown placement="bottomLeft">
                                <!-- <a-menu
                                        slot="overlay"
                                        style="width: 120px"
                                >
                                    <a-menu-item key="panoramic" @click="handlePublishClick">
                                        {{$t("moduleTitles.roampublish")}}
                                    </a-menu-item>
                                    <a-menu-item key="panoramicLive" @click="handleLiveClick">
                                        {{$t("moduleTitles.pclive")}}
                                    </a-menu-item>
                                </a-menu> -->
                                <a-button style="margin-left: 8px"
                                    :style="{ background: '#1c7d83' }"
                                    type="primary" @click="handlePublishClick">
                                    {{ $t("moduleTitles.roampublish") }}
                                    <!-- <a-icon type="down"/> -->
                                </a-button>
                            </a-dropdown>

                        </a-menu>
                    </a-col>
                </a-row>
            </a-layout-header>
        </a-affix>
        <a-layout style="margin:16px 0;">
            <a-layout-sider :style="{ position: 'fixed', left: 0, height: 'calc(100vh - 96px )', background: '#fff', }"
                class="sider-block">
                <a-menu :default-selected-keys="activeSidebarMenu" :selected-keys="activeSidebarMenu"
                    :style="{ borderRight: 0, background: '#ffffff' }">
                    <a-menu-item @click="handleMenuClick" :key="resolveSidebarMenuPath(route.path)"
                        v-for="route in sidebarMenus">
                        <a-icon v-bind:type="route.meta.icon" />
                        {{$t(`moduleTitles.${route.meta.title}`)}}
                    </a-menu-item>
                </a-menu>
                <div class="storage-wrapper" v-if="userDetail.team_id > 0">
                    <a-progress :percent="userDetail.team_capacity_ratio" :show-info="false" />
                    <span class="storage-percent">{{ userDetail.team_use_capacity }}G/{{ userDetail.team_capacity }}G</span>
                    <span class="storage-description">{{ $t('descriptions.spaceCapacity') }}</span>
                </div>
                <div class="storage-wrapper" v-else>
                    <a-progress :percent="userDetail.progress" :show-info="false" />
                    <span class="storage-percent">{{ userDetail.g_use_capacity }}G/{{ userDetail.g_capacity }}G</span>
                    <span class="storage-description">{{ $t('descriptions.spaceCapacity') }}</span>
                </div>
            </a-layout-sider>
            <a-layout-content :style="{ marginLeft: '200px' }">
                <a-layout style="padding: 0px 16px 0 16px; min-height: calc(100vh - 96px )">
                    <breadcrumb v-if="$route.meta.showBreadcrumb" />
                    <a-layout-content>
                        <router-view />
                    </a-layout-content>
                </a-layout>
            </a-layout-content>
        </a-layout>

        <!-- 切換帳號彈出框 -->
        <a-modal v-model="changeVisible" :title="$t('form.team.changeAccount')" :footer="null" :destroyOnClose="true"
            :maskClosable="false" :width="600">
            <div class="change-member-box">
                <!--        個人帳號-->
                <div>
                    <label>{{ $t('form.team.personal') + '' + $t('form.common.field.account.label') }}</label>
                    <a-row class="account-box" :gutter="12" v-if="currentAccount && Object.keys(currentAccount).length">
                        <a-col :span="12">
                            <div class="lists" @click="changeMember()">
                                <img :src="currentAccount.avatar ? currentAccount.avatar : avatar" />
                                <div class="contents">
                                    <h4>{{ currentAccount.name }}</h4>
                                    <h5>{{ currentAccount.phone }}</h5>
                                </div>
                                <span v-if="currentTeamId == 0">{{ $t('form.team.currUse') }}</span>
                            </div>
                        </a-col>
                    </a-row>
                </div>
                <!--        我創建的團隊-->
                <div v-if="currentAccount && currentAccount.is_team_member">
                    <label>{{ $t('form.team.createTeam') }}</label>
                    <a-row class="account-box" :gutter="12" v-if="Object.keys(myTeam).length">
                        <a-col :span="12">
                            <div class="lists" @click="changeMember(myTeam)">
                                <img :src="myTeam.logo ? myTeam.logo : avatar" />
                                <div class="contents">
                                    <h4>{{ myTeam.name }}</h4>
                                    <h5>{{ myTeam.phone }}</h5>
                                </div>
                                <span v-if="currentTeamId == myTeam.id">{{ $t('form.team.currUse') }}</span>
                            </div>
                        </a-col>
                    </a-row>
                    <div class="empty-box" v-else>{{ $t('form.team.createMsg') }}</div>
                </div>
                <!--        我加入的團隊-->
                <div>
                    <label>{{ $t('form.team.joinTeam') }}</label>
                    <a-row class="account-box" :gutter="12" v-if="teamList.length">
                        <a-col :span="12" v-for="item in teamList" :key="item.id">
                            <div class="lists" @click="changeMember(item)">
                                <img :src="item.logo ? item.logo : avatar" />
                                <div class="contents">
                                    <h4>{{ item.name }}</h4>
                                    <h5>{{ item.phone }}</h5>
                                </div>
                                <span v-if="currentTeamId == item.id">{{ $t('form.team.currUse') }}</span>
                            </div>
                        </a-col>
                    </a-row>
                    <div class="empty-box" v-else>{{ $t('form.team.joinMsg') }}</div>
                </div>
            </div>
        </a-modal>
    </a-layout>
</template>

<script>
import path from "path";
import { mapState } from "vuex";
import { memberRoutes } from "@/router";
import Breadcrumb from "@/components/Breadcrumb";
import "../assets/css/main.less";
import { getUserInfo } from "@/api/user";
import { getUserTeamList, changeTeam } from "@/api/team";

export default {
    name: "MemberLayout",
    components: { Breadcrumb },
    data() {
        return {
            showMenu: true,
            currentUser: {
                name: this.$t('enum.userType.2'),
            },
            memberRoutes,
            userDetail: {},
            avatar: require('@/assets/default_h.jpg'),

            changeVisible: false,
            currentAccount: null,
            myTeam: {},
            teamList: [],
            is_team_member: -1,
            uvclogo: '/ssr/static/images/UVClogo.png'
        };
    },
    mounted() {
        getUserInfo().then((res) => {
            this.userDetail = res.data;
        });

    },
    computed: {
        ...mapState({
            sidebar: (state) => state.app.sidebar,
            device: (state) => state.app.device,
            showSettings: (state) => state.settings.showSettings,
            needTagsView: (state) => state.settings.tagsView,
            fixedHeader: (state) => state.settings.fixedHeader,
            userInfo: (state) => state.user.userInfo,
            siteInfo: (state) => state.siteConfig.siteInfo,
        }),
        classObj() {
            return {
                hideSidebar: !this.sidebar.opened,
                openSidebar: this.sidebar.opened,
                withoutAnimation: this.sidebar.withoutAnimation,
                mobile: this.device === "mobile",
            };
        },
        activeTopbarMenu() {
            return [this.$route.matched[1].path];
        },

        sidebarMenus() {
            let pathArr = this.$route.matched[1].path.split("/");
            let firstRoute = this.memberRoutes[0].children.find(
                (p) => p.path === pathArr[2]
            );
            return firstRoute.children.filter((p) => {
                return !p.meta.hidden;
            });
        },
        activeSidebarMenu() {
            return [this.$route.matched[2].path];
        },
        // 判斷顯示頂部導航
        topbarMenus() {
            console.log('this.memberRoutes:', this.memberRoutes);
            if (this.userInfo.team_id > 0) {
                return this.memberRoutes[0].children.filter(function (item) {
                    return !item.hidden;
                });
            } else {
                if (this.userInfo.level > 0) {
                    return this.memberRoutes[0].children.filter(function (item) {
                        return !item.hidden && !item.team;
                    });
                } else {
                    return this.memberRoutes[0].children.filter(function (item) {
                        return !item.hidden && !item.team && (item.level != 0);
                    });
                }
            }

        },
        currentTeamId() {
            let id = parseInt(this.userInfo.team_id)
            return id
        }
    },
    methods: {
        test() {
                return this.siteInfo.logo
        },
        //打開切換團隊
        openChangeMember() {
            this.getUserTeamList()
            this.changeVisible = true
        },
        //獲取團隊列表
        getUserTeamList() {
            getUserTeamList().then(res => {
                const data = res.data;
                const adminTeam = data.adminTeam ? data.adminTeam : {};

                this.currentAccount = data.user_info
                this.myTeam = adminTeam
                this.teamList = data.teamList
            }).catch(err => {
                console.log(err)
            })
        },
        //切換團隊
        changeMember(item = {}) {
            const id = Object.keys(item).length ? item.id : 0
            const team_path = this.$route.path.indexOf('/member/team') != -1 ? true : false
            const project_path = this.$route.path.indexOf('/member/project') != -1 ? true : false
            console.log(project_path, this.userInfo)
            changeTeam({ team_id: id }).then(res => {
                if (res.code == 1) {
                    this.$message.success(res.message, 1)
                    this.changeVisible = false
                    setTimeout(() => {
                        if ((team_path && id == 0) || (project_path && this.userInfo.level == 0)) {

                            this.$router.push({
                                name: 'memberAccountBasic',
                                params: { change_team: 1 }
                            })
                        } else {
                            window.location.reload();
                        }
                    }, 1000)

                }
            }).catch(err => {
                console.log(err)
            })
        },
        goHome() {
            window.open("/author/" + this.userInfo.id);
        },
        handleClickOutside() {
            this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
        },
        resolvePath(basePath, routePath) {
            return path.resolve(basePath, routePath);
        },
        resolveSidebarMenuPath(routePath) {
            return path.resolve(this.$route.matched[1].path, routePath);
        },
        handleMenuClick({ item, key, keyPath }) {
            // console.log(item, key, keyPath);
            this.$router.push(key);
        },
        handlePublishClick() {
            let name = this.$isMobile() ? "mbpublish" : "pcpublish";
            this.$router.push({ name });
        },
        handleLiveClick() {
            // let name = this.$isMobile() ? "mbpublish" : "pcpublish";
            this.$router.push({ name: "live" });
        },
        onClickLoginout() {
            this.$store
                .dispatch("logout")
                .then((res) => {
                    this.$message.success(res.message);
                })
                .catch((err) => {
                    this.$message.error(err);
                });
        },
    },
};
</script>

<style lang="less" scoped>
//切換團隊
.change-member-box {
    label {
        font-size: 14px;
        color: #000;
        margin-bottom: 15px;
        display: inline-block;
    }

    .empty-box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 40px 0;
        color: #555;
    }

    .account-box {
        .lists {
            position: relative;
            display: flex;
            align-items: center;
            padding: 15px;
            margin-bottom: 12px;
            border-radius: 10px;
            overflow: hidden;
            border: 1px solid #e8e8e8;
            box-shadow: 0 0 8px 3px rgba(0, 0, 0, .03);
            cursor: pointer;

            &:hover {
                background-color: #f9f9f9;
            }

            img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                flex-shrink: 0;
                margin-right: 14px;
            }

            .contents {
                h4 {
                    font-size: 14px;
                    color: #555;
                    margin-bottom: 0;
                }

                h5 {
                    font-size: 12px;
                    color: #aaa;
                    margin-bottom: 0;
                }
            }

            &>span {
                position: absolute;
                top: 0;
                right: 0;
                z-index: 10;
                padding: 4px 10px;
                background-color: #0d95e8;
                color: #fff;
                font-size: 12px;
                border-radius: 0 0 0 10px;
            }
        }
    }
}

.ant-layout-header {
    background: rgba(19, 113, 202, 1);
}

.ant-menu-horizontal>.ant-menu-item:hover,
.ant-menu-horizontal>.ant-menu-submenu:hover,
.ant-menu-horizontal>.ant-menu-item-active,
.ant-menu-horizontal>.ant-menu-submenu-active,
.ant-menu-horizontal>.ant-menu-item-open,
.ant-menu-horizontal>.ant-menu-submenu-open,
.ant-menu-horizontal>.ant-menu-item-selected,
.ant-menu-horizontal>.ant-menu-submenu-selected {
    color: #ffff;
    border: 0;
}

.ant-menu-horizontal>.ant-menu-item:hover>span,
.ant-menu-horizontal>.ant-menu-submenu:hover>span,
.ant-menu-horizontal>.ant-menu-item-active>span,
.ant-menu-horizontal>.ant-menu-submenu-active>span,
.ant-menu-horizontal>.ant-menu-item-open>span,
.ant-menu-horizontal>.ant-menu-submenu-open>span,
.ant-menu-horizontal>.ant-menu-item-selected>span,
.ant-menu-horizontal>.ant-menu-submenu-selected>span {
    color: #ffff;
    border-bottom: 2px solid #fff;
}

.logo-wrapper {
    position: absolute;
    overflow: hidden;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}

.logo-image {
    width: 160px;
}

.header-right {
    float: right;
    cursor: pointer;
    padding-left: 50px;
    padding-right: 10px;
    margin-left: 50px;
    overflow: hidden;
    color: hsla(0, 0%, 100%, 0.85);
    height: 64px;
    line-height: normal;
    position: relative;

    &:hover {
        background: rgba(0, 0, 0, 0.25);
    }

    // .account-avatar {
    //   width: 24px;
    //   height: 24px;
    //   line-height: 24px;
    // }
    .header-avatar {
        position: absolute;
        top: 15px;
        left: 10px;
    }

    .header-right-name {
        margin-top: 12px;
        display: inline-block;
    }

    .header-right-text {
        color: rgba(255, 255, 255, .7);
        font-size: 12px;
        margin-top: 3px;
    }
}

.ant-pro-drop-down {
    /deep/ .action {
        margin-right: 8px;
    }

    /deep/ .ant-dropdown-menu-item {
        min-width: 160px;
    }
}

.storage-wrapper {
    height: 50px;
    position: relative;
    padding: 0 10px 0 10px;

    .storage-percent {
        font-size: 14px;
        color: rgb(153, 153, 153);
    }

    .storage-description {
        position: absolute;
        color: rgb(48, 48, 48);
        font-size: 14px;
        right: 10px;
    }
}

.ant-menu-horizontal {
    border: 0;
}

.ant-menu-horizontal>.ant-menu-item,
.ant-menu-horizontal>.ant-menu-submenu {
    border: 0;
}

.ant-menu-item>span {
    display: inline-block;
    line-height: 35px;
}

.sider-block /deep/ .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 5px 0 20px;
}

.uvcbg {
    background-color: #7101AD;
}

.ant-layout-header {
    background-color: #015c61;
}
// .metaTitle {
//     background-color: #e4b3ff;
// }
</style>
